import { createElement, type ComponentType } from "react"
import { GoldenDustImg, Labr3dIcon, StarIcon, Ton3dIcon } from "@/assets"
import { CURRENCY, ICurrency } from "@/store/apis/balanceAPI"

export const CurrencyIcon: Record<ICurrency, ComponentType> = {
  [CURRENCY.TON]: Ton3dIcon,
  [CURRENCY.STAR]: StarIcon,
  [CURRENCY.LABR]: Labr3dIcon,
  [CURRENCY.GOLDEN_DUST]: () =>
    createElement("img", { src: GoldenDustImg, alt: "golden dust" })
}
